import { https } from "../http";
import store from "../store";
import {
  setSkypointProject,
  setSkypointProjectLoading,
  setSkypointProjectStatus,
} from "../store/reducers/skypointProject";
import { showError } from "../utils";
import swal from "sweetalert";
import { getDashboardProjectTasksSkypoint } from "./dashboard";

const addSkypointProjectTask = async (data) => {
  try {
    let response = await https().post("/skypointProject", data);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      getAllSkypointProjectTasks(1);
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getAllSkypointProjectTasks = async (
  page = 1,
  search = "",
  showLoading = true
) => {
  try {
    const strUrl = `/skypointProject/${page}${
      search ? `?search=${search}` : ""
    }`;
    if (showLoading) store.dispatch(setSkypointProjectLoading(true));
    let response = await https().get(strUrl);
    if (response?.status === 200) {
      store.dispatch(setSkypointProject(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointProjectLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateSkypointProjectTask = async (data, callBack) => {
  try {
    let response = await https().put("/skypointProject", data);
    if (response?.status === 200) {
      // swal({
      //   title: response?.data?.message,
      //   icon: "success",
      //   dangerMode: false,
      // });
      callBack ? callBack?.() : getAllSkypointProjectTasks(1);
      getDashboardProjectTasksSkypoint();
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const deleteSkypointProjectTask = async (id) => {
  try {
    let response = await https().delete(`/skypointProject/${id}`);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message || "",
        icon: "success",
        dangerMode: false,
      });
      getAllSkypointProjectTasks(1);
      getDashboardProjectTasksSkypoint();
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const addSkypointProjectTaskStatus = async (data) => {
  try {
    let response = await https().post("/skypointProject/add-status", data);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      await getSkypointProjectTaskStatus();
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const getSkypointProjectTaskStatus = async () => {
  try {
    const strUrl = `/skypointProject/all-status`;
    let response = await https().get(strUrl);
    if (response?.status === 200) {
      store.dispatch(setSkypointProjectStatus(response?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const deleteSkypointProjectTaskStatus = async (id) => {
  try {
    let response = await https().delete(`/skypointProject/status/${id}`);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message || "Status deleted successfully",
        icon: "success",
        dangerMode: false,
      });
      await getSkypointProjectTaskStatus();
      getAllSkypointProjectTasks("all");
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  addSkypointProjectTask,
  getAllSkypointProjectTasks,
  updateSkypointProjectTask,
  deleteSkypointProjectTask,
  addSkypointProjectTaskStatus,
  getSkypointProjectTaskStatus,
  deleteSkypointProjectTaskStatus,
};
